// Copyright (c) 2025 Cloudflare, Inc.
// Licensed under the MIT license found in the LICENSE.txt file or at:
//     https://opensource.org/license/mit

export let WORKERS_MODULE_SYMBOL = Symbol("workers-module");
